<template>
  <div class="company-wall-products-skeleton">
    <SButtonSkeleton
      v-for="(width, index) in widths"
      :key="index"
      size="md"
      :width="width"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { SButtonSkeleton } from "@solvari/components";

const props = withDefaults(
  defineProps<{
    amount?: number;
  }>(),
  { amount: 3 },
);

const widthCycle = ["7rem", "8rem", "9rem", "10rem", "11rem"];
const widths = computed(() =>
  Array.from(
    { length: props.amount },
    (_value, index) => widthCycle[index % widthCycle.length],
  ),
);
</script>

<style lang="postcss">
.company-wall-products-skeleton {
  @apply flex flex-col gap-y-2;

  @screen 600 {
    @apply flex-row flex-wrap gap-x-4 gap-y-0;
  }
}
</style>
